import {call, put, select} from "redux-saga/effects";
import api from "../../services/api";
import {Creators as ClientesActions} from "../ducks/clientes";
import {Creators as PropostasActions} from "../ducks/propostas";
import {Creators as PropostasAlertasActions} from "../ducks/propostasAlertas";
import {Creators as ClientesStoresActions} from "../ducks/PageStores/clientesStores";
import {Creators as ModalCadastroClientesActions} from "../ducks/modalCadastroClientes";
import {Creators as ModalEdicaoClientesActions} from "../ducks/modalEdicaoClientes";
import {Creators as ModalCustomerActions} from "../ducks/modalCustomer";
import {Creators as ModalPhotoActions} from "../ducks/modalPhoto";
import {Creators as ModalDocsActions} from "../ducks/modalDocs";
import {Creators as AlertActions} from "../ducks/alert";
import {Creators as ErrorActions} from "../ducks/error";
import {Creators as SuccessActions} from "../ducks/success";
import {Creators as LoadingActions} from "../ducks/loading";
import {formatSize} from "../../helpers";
import moment from "moment";

export function* getListClientes() {
  try {
    yield put(LoadingActions.setLoading());
    const {page, rowsPerPage, filter} = yield select(state => state.clientes);
    const {action} = yield select(state => state.clientesStores);
    if (action === "EXPORT") {
      filter.export = true;
    }
    const {data} = yield call(
      api.post,
      `/customers/filter?page=${page + 1}&&per_page=${rowsPerPage}`,
      filter
    );
    const {data: clientes, total} = data;
    let clientesPayload = [];
    clientesPayload = clientes.map(cliente => ({
      id: cliente.id,
      name: cliente.name
        ? `${
          moment(cliente.birthday).format("DD/MM") ===
          moment().format("DD/MM")
            ? "🎂🎈"
            : ""
          }  <span>${
          cliente.dead
            ? '<img src="data:image/svg+xml;base64,&#13;&#10;PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii03NiAwIDUxMiA1MTIiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiBjbGFzcz0iIj48Zz48cGF0aCBkPSJtMjI1IDUxMnYtMzAxaDEzNXYtOTBoLTEzNXYtMTIxaC05MHYxMjFoLTEzNXY5MGgxMzV2MzAxem0wIDAiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgc3R5bGU9ImZpbGw6IzQzNDM0MyIgZGF0YS1vbGRfY29sb3I9IiNSR0JBKDAiPjwvcGF0aD48L2c+IDwvc3ZnPg==" title="" style="width: 1.3rem; margin-right: 0.3rem; top: .2rem; position: relative;">'
            : ""
          } ${
          cliente.blacklisted
            ? '<i class="fa fa-exclamation-circle" style="margin-right: 0.3rem; font-size: 1.5rem; color: #f86c6b; top: .1rem; position: relative;"></i>'
            : ""
        } ${
          cliente.illiterate
            ? '<svg style="width: 1.3rem; margin-right: 0.3rem; top: .2rem; position: relative;" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"></path></svg>'
            : ""
        } ${cliente.name} </span>`
        : "",
      cpf_cnpj: cliente.cpf_cnpj ? cliente.cpf_cnpj : "",
      rg: cliente.rg ? cliente.rg : "",
      birthday: cliente.birthday
        ? moment(cliente.birthday).format("DD/MM/YYYY")
        : "",
      age: cliente.birthday
        ? `${moment().format("YYYY") -
        moment(cliente.birthday).format("YYYY")} anos`
        : "",
      address:
        cliente.addresses && cliente.addresses.length > 0
          ? `${
            cliente.addresses[0].city ? cliente.addresses[0].city + "/" : ""
            }${cliente.addresses[0].state ? cliente.addresses[0].state : ""}`
          : "",
      contacts:
        cliente.contacts && cliente.contacts.length > 0
          ? cliente.contacts
            .map(contact => `<span class="tel">${contact.number}</span>`)
            .join("")
          : "",
      docs:
        cliente.files.length > 0
          ? `<span class='s-docs ${cliente.notes && "docs-not-ok-warning"}'>
                <span class='tag-child'>
                  <span class='tag-row'>
                    ${
            cliente.notes
              ? `Este cliente possui documentos anexados. <br/>
                          Observações: ${cliente.notes}`
              : "Este cliente possui documentos anexados"
            }
                  </span>
                </span>
                <i class='fa fa-folder fa-lg has-files'/>
            </span>`
          : `<span class='s-docs ${cliente.notes && "docs-not-ok-warning"}'>
                <span class='tag-child'>
                  <span class='tag-row'>
                    ${
            cliente.notes
              ? `Este cliente não possui documentos anexados. <br/>
                        Observações: ${cliente.notes}`
              : "Este cliente não possui documentos anexados"
            }
                  </span>
                </span>
                <i class='fa fa-folder-o fa-lg'/>
             </span>`
    }));
    yield put(
      ClientesActions.getListClientesSuccess(
        clientesPayload,
        total,
        data.export
      )
    );
    if (action === "EXPORT") {
      window.open(data.export, "_blank");
      yield put(ClientesStoresActions.setClienteAction("LIST"));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getClientes({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {data} = yield call(api.get, `/customers/${payload.id}`);
    data.cpf_cnpj = data.cpf_cnpj ? data.cpf_cnpj : "";
    data.birthday = data.birthday
      ? moment(data.birthday).format("DD/MM/YYYY")
      : "";
    data.marital_status = data.marital_status
      ? data.marital_status.toUpperCase()
      : "";
    data.gender = data.gender ? data.gender.toUpperCase() : "";
    data.rg = data.rg ? data.rg : "";
    data.rg_date = data.rg_date
      ? moment(data.rg_date).format("DD/MM/YYYY")
      : "";
    data.rg_org = data.rg_org ? data.rg_org : "";
    data.rg_uf = data.rg_uf ? data.rg_uf : "";
    data.father_name = data.father_name ? data.father_name : "";
    data.mother_name = data.mother_name ? data.mother_name : "";
    data.relation_name = data.relation_name ? data.relation_name : "";
    data.email = data.email ? data.email : "";
    data.email_commercial = data.email_commercial ? data.email_commercial : "";
    data.admission_date = data.admission_date
      ? moment(data.admission_date).format("DD/MM/YYYY")
      : "";
    data.salary = data.salary ? data.salary : "";
    data.demission_date = data.demission_date
      ? moment(data.demission_date).format("DD/MM/YYYY")
      : "";
    data.obs = data.obs ? data.obs : "";
    data.contacts =
      data.contacts && data.contacts.length > 0
        ? data.contacts.map(contact => {
          contact.type = contact.type ? contact.type.toUpperCase() : "";
          contact.notes = contact.notes ? contact.notes.toUpperCase() : "";
          contact.type_reference = contact.type_reference
            ? contact.type_reference.toUpperCase()
            : "";
          return contact;
        })
        : [];
    data.files =
      data.files && data.files.length > 0
        ? data.files.map(file => {
          file.updated_at = file.updated_at ? moment(file.updated_at).format("DD/MM/YYYY HH:mm:ss") : "";
          file.created_at = file.created_at ? moment(file.created_at).format("DD/MM/YYYY HH:mm:ss") : "";
          file.user_name = file.user ? file.user.name : "";
          file.size = file.size ? formatSize(file.size) : "";
          return file;
        })
        : [];
    yield put(ClientesActions.getClientesSuccess(data));
    const {action} = yield select(state => state.clientesStores);
    if (action === "EDIT" || action === "DETAIL") {
      yield put(ModalEdicaoClientesActions.openModalEdicaoClientes());
    } else if (action === "EDIT_CUSTOMER_SALES" || action === "DETAIL_THIRD") {
      yield put(ModalCustomerActions.openCustomerModal());
    } else if (action === "PHOTO") {
      yield put(ModalPhotoActions.openPhotoModal());
    } else if (action === "DOCS") {
      yield put(ModalDocsActions.openDocsModal());
    } else {
      const title = "Aviso de exclusão";
      const body = `O cliente "${data.name}" será excluido do sistema.`;
      yield put(AlertActions.openAlert(title, body));
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* editClientes({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {action} = yield select(state => state.clientesStores);
    yield call(api.put, `/customers/${payload.id}`, payload);
    const {actionProposta} = yield select(state => state.propostasStores);
    const {currentPageName} = yield select(state => state.pages);
    if (action === "EDIT") {
      yield put(ClientesActions.getListClientes());
      yield put(ModalEdicaoClientesActions.closeModalEdicaoClientes());
    } else if (action === "EDIT_CUSTOMER_SALES") {
      if (actionProposta === "LIST") {
        if (currentPageName === "Propostas") {
          yield put(PropostasActions.getListPropostas());
        } else {
          yield put(PropostasAlertasActions.getListPropostasAlertas());
        }
      } else {
        if (currentPageName === "Propostas") {
          yield put(PropostasActions.getListPropostas());
        } else {
          yield put(PropostasAlertasActions.getListPropostasAlertas());
        }
      }
      yield put(ModalCustomerActions.closeCustomerModal());
    }
    yield put(SuccessActions.openSuccess("Cliente editado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
    yield put(LoadingActions.unsetLoading());
  }
}

export function* addClientes({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {action} = yield select(state => state.clientesStores);
    yield call(api.post, `/customers`, payload);
    if (action === "NEW") {
      yield put(ClientesActions.searchClientes({}));
      yield put(ClientesActions.getListClientes());
      yield put(ModalCadastroClientesActions.closeModalCadastroClientes());
    } else if (action === "NEW_CUSTOMER_SALES") {
      yield put(ModalCustomerActions.closeCustomerModal());
    }
    yield put(
      ClientesStoresActions.setFields({
        contacts: [],
        references: [],
        benefits: []
      })
    );
    yield put(SuccessActions.openSuccess("Cliente adicionado com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteClientes() {
  try {
    yield put(LoadingActions.setLoading());
    const {id} = yield select(state => state.clientes.item);
    yield call(api.delete, `/customers/${id}`);
    yield put(ClientesActions.getListClientes());
    yield put(SuccessActions.openSuccess("Cliente excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* searchClientes() {
  try {
    yield put(ClientesActions.getListClientes());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* getListClientesSelects() {
  try {
    const {data: clientes} = yield call(api.get, `/customers/select`);
    yield put(ClientesActions.getListClientesSuccessSelects(clientes));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* deleteAllClientes({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    yield call(api.delete, `/customers/`, {
      customers: payload.selected
    });
    yield put(ClientesActions.getListClientes());
    yield put(SuccessActions.openSuccess("Cadastros excluídos com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}

export function* getClientesDocs({payload}) {
  try {
    yield put(LoadingActions.setLoading());
    const {data} = yield call(api.get, `/customers/${payload.id}/docs`);
    data.files =
      data.files && data.files.length > 0
        ? data.files.map(file => {
          file.updated_at = file.updated_at ? moment(file.updated_at).format("DD/MM/YYYY HH:mm:ss") : "";
          file.created_at = file.created_at ? moment(file.created_at).format("DD/MM/YYYY HH:mm:ss") : "";
          file.user_name = file.user ? file.user.name : "";
          file.size = file.size ? formatSize(file.size) : "";
          return file;
        })
        : [];
    yield put(ClientesActions.getClientesDocsSuccess(data));
      yield put(ModalDocsActions.openDocsModal());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/clientes.js